import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LetDirective } from '@directives/app-let.directive';
import { GrowthBookFeatureKeys } from '@models/growthbook.models';
import { Station } from '@models/responses/station-response.model';
import { Store } from '@ngrx/store';
import { selectSearchInputCriteriaState } from '@selectors/availability.selector';
import { selectAppCmsCopy } from '@selectors/cms.selector';
import { selectStationsState } from '@selectors/station.selector';
import { GrowthBookService } from '@services/growthbook/growthbook.service';

@Component({
  selector: 'app-flights-loader',
  standalone: true,
  imports: [
    CommonModule,
    LetDirective,
  ],
  templateUrl: './flights-loader.component.html',
  styleUrl: './flights-loader.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FlightsLoaderComponent implements OnInit {
  destroyRef = inject(DestroyRef);
  searchCriteria$ = this.store.select(selectSearchInputCriteriaState);
  stations$ = this.store.select(selectStationsState);
  appCms$ = this.store.select(selectAppCmsCopy);

  readonly gbf = GrowthBookFeatureKeys;
  constructor(private readonly store: Store, public readonly gbs: GrowthBookService, private readonly cd: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.initChangeDetection();
  }

  initChangeDetection() {
    this.gbs.onChange$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.cd.detectChanges();
    });
  }

  getCityName(code: string | undefined, stations: Station[] | null) {
    if (!code) {
      return '';
    }

    if (!stations) {
      return code;
    }

    return stations.find(s => s.stationCode === code)?.fullName ?? code;
  }

  pasteCityName(cityName: string, html: string) {
    return html.replace("{{cityName}}", cityName)
  }
}
